export enum StationActionTypes {
  GET_STATIONS = "@@STATION/GET_STATIONS",
  GET_STATIONS_SUCCESS = "@@STATION/GET_STATIONS_SUCCESS",
  GET_STATIONS_FAILURE = "@@STATION/GET_STATIONS_FAILURE",

  GET_STATION_RAW_DATA = "@@STATION/GET_STATION_RAW_DATA",
  GET_STATION_RAW_DATA_SUCCESS = "@@STATION/GET_STATION_RAW_DATA_SUCCESS",
  GET_STATION_RAW_DATA_FAILURE = "@@STATION/GET_STATION_RAW_DATA_FAILURE",

  GET_STATIONS_CONNECTIONS = "@@STATION/GET_STATIONS_CONNECTIONS",
  GET_STATIONS_CONNECTIONS_SUCCESS = "@@STATION/GET_STATIONS_CONNECTIONS_SUCCESS",
  GET_STATIONS_CONNECTIONS_FAILURE = "@@STATION/GET_STATIONS_CONNECTIONS_FAILURE",

  CREATE_STATION = "@@STATION/CREATE_STATION",
  CREATE_STATION_SUCCESS = "@@STATION/CREATE_STATION_SUCCESS",
  CREATE_STATION_FAILURE = "@@STATION/CREATE_STATION_FAILURE",

  UPDATE_STATION = "@@STATION/UPDATE_STATION",
  UPDATE_STATION_SUCCESS = "@@STATION/UPDATE_STATION_SUCCESS",
  UPDATE_STATION_FAILURE = "@@STATION/UPDATE_STATION_FAILURE",

  ACTIVATE_DEACTIVATE_STATION = "@@STATION/ACTIVATE_DEACTIVATE_STATION",
  ACTIVATE_DEACTIVATE_STATION_SUCCESS = "@@STATION/ACTIVATE_DEACTIVATE_STATION_SUCCESS",
  ACTIVATE_DEACTIVATE_STATION_FAILURE = "@@STATION/ACTIVATE_DEACTIVATE_STATION_FAILURE",

  LOAD_STATIONS_ISSUES = "@@STATION/LOAD_STATIONS_ISSUES",
  LOAD_STATIONS_ISSUES_SUCCESS = "@@STATION/LOAD_STATIONS_ISSUES_SUCCESS",
  LOAD_STATIONS_ISSUES_FAILURE = "@@STATION/LOAD_STATIONS_ISSUES_FAILURE",

  READ_STATION_ISSUE = "@@STATION/READ_STATION_ISSUE",
  READ_STATION_ISSUE_SUCCESS = "@@STATION/READ_STATION_ISSUE_SUCCESS",
  READ_STATION_ISSUE_FAILURE = "@@STATION/READ_STATION_ISSUE_FAILURE",

  SET_STATIONS_ISSUES_FILTER = "@@STATION/SET_STATIONS_ISSUES_FILTER",

  CLEAR_STATIONS = "@@STATION/CLEAR_USERS",
  SET_FILTER = "@@STATION/SET_FILTER",
  SET_STATION_VIEW_RAW_DATA_FILTER = "@@STATION/SET_STATION_VIEW_RAW_DATA_FILTER",
}
